import { getDomainITPL, getDomainSAG } from "utils/helpers";

// Navigation Links
export const navLinks = [
  {
    label: "About Us",
    path: getDomainITPL(),
  },
  {
    label: "Our Team",
    path: `${getDomainITPL()}/our-team`,
  },
  {
    label: "Our Qualifications",
    path: "#",
    dropdownItems: [
      {
        label: "Qualifications",
        path: `${getDomainITPL()}/our-qualifications/courses`,
      },
      {
        label: "Self Assessment Guides",
        path: getDomainSAG(),
      },
      {
        label: "Industry Recognition",
        path: `${getDomainITPL()}/our-qualifications/industry-professional-certification`,
      },
    ],
  },
  {
    label: "Short Course",
    path: "#",
    dropdownItems: [
      {
        label: "Computer Based Simulations",
        path: `${getDomainITPL()}/short-course/computer-based-simulations`,
      },
    ],
  },
  {
    label: "News",
    path: `${getDomainITPL()}/news`,
  },
  {
    label: "Training Partner",
    path: "#",
    dropdownItems: [
      {
        label: "Aspire",
        path: `${getDomainITPL()}/training-partner/aspire`,
      },
      {
        label: "IPMA",
        path: `${getDomainITPL()}/training-partner/ipma`,
      },
    ],
  },
  {
    label: "Contact Us",
    path: `${getDomainITPL()}/contact-us`,
  },
];

export const navLinksMobile = [
  {
    label: "About Us",
    path: getDomainITPL(),
  },
  {
    label: "Our Team",
    path: `${getDomainITPL()}/our-team`,
  },
  {
    label: "Our Qualifications",
    path: "#",
    dropdownItems: [
      {
        label: "Qualifications",
        path: `${getDomainITPL()}/our-qualifications/courses`,
      },
      {
        label: "Self Assessment Guides",
        path: getDomainSAG(),
      },
      {
        label: "Industry Recognition",
        path: `${getDomainITPL()}/our-qualifications/industry-professional-certification`,
      },
    ],
  },
  {
    label: "Short Course",
    path: "#",
    dropdownItems: [
      {
        label: "Computer Based Simulations",
        path: `${getDomainITPL()}/short-course/computer-based-simulations`,
      },
    ],
  },
  {
    label: "News",
    path: `${getDomainITPL()}/news`,
  },
  {
    label: "Training Partner",
    path: "#",
    dropdownItems: [
      {
        label: "Aspire",
        path: `${getDomainITPL()}/training-partner/aspire`,
      },
      {
        label: "IPMA",
        path: `${getDomainITPL()}/training-partner/ipma`,
      },
    ],
  },
  {
    label: "Contact Us",
    path: `${getDomainITPL()}/contact-us`,
  },
];

// Questionnaire Data
export const dpm_assessment_form = {
  name: "Project Management - Self Assessment Grid",
  list: [
    {
      subject: "Project Initiation",
      description: [
        "Developed a Business Case",
        "Established Project Governance",
        "Developed a Project Charter",
      ],
    },
    {
      subject: "Project Planning",
      description: [
        "Managed Project Scope",
        "Managed Project Time",
        "Managed Project Quality",
        "Managed Project Costs",
        "Managed Project Human Resources",
        "Managed Project Information & Communications",
        "Managed Project Risk",
        "Managed Project Procurement",
        "Managed Project Stakeholder Engagement",
        "Managed Project Governance",
        "Managed Project Integration in including writing a PMP",
        "Managed Meetings",
      ],
    },
    {
      subject: "Project Implementation",
      description: [
        "Conducted a Project Kick-Off Meeting",
        "Managed changes to the baseline plan (PMP and all its supporting plans)",
        "Measured Project Progress e.g. Using Earned Value",
        "Reviewed team & individual performance",
        "Conducted negotiations and resolved conflicts",
        "Prepared a project progress report",
      ],
    },
    {
      subject: "Project Closure",
      description: [
        "Closed the administrative aspects of the project",
        "Conducted a project closure meeting",
        "Reassigned resources",
        "Written a Project Closure report that included lessons learned",
      ],
    },
    {
      subject: "Benefits Realization",
      description: [
        "Measured the benefits of a project",
        "Closed a Business Case",
      ],
    },
  ],
};

export const adpm_assessment_form = {
  name: "Level 6 Program Management - Self Assessment Grid",
  list: [
    {
      subject: "Develop a Business Case",
      description: [
        "Identified and confirmed a business problem",
        "Analyzed key stakeholder requirements to clarify objectives",
        "Considered a range of factors to identify opportunities and constraints",
        "Conducted market analysis",
        "Examined business solutions",
        "Constructed a business case",
        "Finalized a business case",
      ],
    },
    {
      subject: "Facilitate Stakeholder Engagement",
      description: [
        "Communicated with stakeholders",
        "Undertaken stakeholder commitment",
        "Assessed effectiveness of stakeholder engagement",
      ],
    },
    {
      subject: "Enable Program Support Services",
      description: [
        "Identify management and governance support needs for the program.",
        "Evaluate and establish appropriate systems to support management and personnel with implementation.",
        "Establish skill development support systems for program personnel to meet program needs.",
        "Implement program knowledge management to support current and future organization requirements for program development.",
      ],
    },
    {
      subject: "Manage Benefits",
      description: [
        "Identified benefits and trade-offs",
        "Executed program to deliver benefits",
        "Sustained and evaluated attainment of expected benefits",
      ],
    },
    {
      subject: "Enable Program Execution",
      description: [
        "Envisioned the desired future state",
        "Shaped and sustained the program execution approach",
        "Established the program governance requirements",
        "Reviewed program execution",
      ],
    },
    {
      subject: "Manage Program Delivery",
      description: [
        "Resourced and funded the program",
        "Monitored program progress",
        "Addressed legal and regulatory requirements",
        "Manage program risks",
      ],
    },
    {
      subject: "Manage Program Risks",
      description: [
        "Directed planning of program risks",
        "Managed program risks",
        "Assessed program risk management outcomes",
      ],
    },
    {
      subject: "Manage Organizational Finances",
      description: [
        "Prepared for financial management",
        "Established budgets and allocated funds",
        "Reported on Finances",
      ],
    },
    {
      subject: "Engage in Collaborative Alliances",
      description: [
        "Identified opportunities for collaboration and developed collaborative alliances",
        "Established collaborative agreements",
        "Supported the evolution of collaborative agreements",
      ],
    },
    {
      subject: "Develop Contracts and Manage Contract Performance",
      description: [
        "Established contracts",
        "Monitored performance and facilitated negotiations",
        "Concluded performance outcomes and recommendations",
      ],
    },
    {
      subject: "Develop Communities of Practice",
      description: [
        "Identify communities of practice requirements",
        "Devised spaces for involvement",
        "Invited participants",
        "Assisted evolution of community",
      ],
    },
    {
      subject: "Lead and Manage Organizational Change",
      description: [
        "Developed a change management strategy",
        "Implemented a change management strategy",
        "Evaluated the change management strategy",
      ],
    },
    {
      subject: "Develop and Use Emotional Intelligence",
      description: [
        "Developed evaluation criteria for assessing emotional strengths and weaknesses",
        "Assessed emotional strengths and weaknesses",
        "Identified potential stressors in the workplace",
        "Developed a plan for responding to emotional expressions",
        "Promoted the development of emotional intelligence in self and others",
      ],
    },
    {
      subject: "Provide Leadership of The Program",
      description: [
        "Established program vision and environment",
        "Managed risks",
        "Supported staff learning",
        "Evaluated leadership",
      ],
    },
    {
      subject: "Lead Corporate Social Responsibility",
      description: [
        "Identified context for corporate social responsibility",
        "Established corporate social responsibility policy",
        "Monitored and evaluated corporate social responsibility",
      ],
    },
  ],
};

export const dc_assessment_form = {
  name: "Consultancy - Self Assessment Grid",
  list: [
    {
      subject: "Prepare consultant contract for engagement with the prospect",
      description: [
        "Established prospect's business context",
        "Established the prospect's requirements",
        "Determined the stakeholder engagement requirements",
        "Established policies that relate to the prospective client",
        "Written a management consultant services proposal",
        "Gained agreement for the contract from the prospect",
      ],
    },
    {
      subject: "Prepare and agree on a consultancy proposal",
      description: [
        "Prepare proposal",
        "Present proposal",
        "Conduct proposal negotiations",
        "Gain approval for proposal",
      ],
    },
    {
      subject:
        "Prepare the work plan for implementation of the consultancy services contract",
      description: [
        "Drafted work plan to meet the contractual requirements",
        "Gained agreement of the work plan",
      ],
    },
    {
      subject: "Apply professional ethics and values",
      description: [
        "Defined professional ethics and values",
        "Monitored the application of professional ethics and values",
        "Sought opportunities for self-improvement",
      ],
    },
    {
      subject: "Execute the consultancy services work plan",
      description: [
        "Presented a consultancy services work plan to clients and stakeholders",
        "Implemented the consultancy services work plan",
        "Monitored and reported work plan progress",
      ],
    },
    {
      subject: "Finalize consultancy services work plan and contract",
      description: [
        "Finalized consultancy services work plan",
        "Finalized consultancy services contract",
        "Conducted consultancy practice administrative closure activities",
      ],
    },
    {
      subject: "Manage a consultancy services provider practice",
      description: [
        "Monitored and reviewed consultancy services practice business plan",
        "Analyze opportunities",
        "Marketed the consultancy practice",
        "Managed consultancy practice operations",
        "Managed practice's finances",
      ],
    },
    {
      subject: "Identify and evaluate marketing opportunities",
      description: [
        "Explored marketing opportunities",
        "Evaluated marketing opportunities",
        "Evaluated required changes to current operations",
      ],
    },
    {
      subject: "Research and develop business plans",
      description: [
        "Prepared to develop a business plan",
        "Drafted a business plan",
        "Created a business plan",
        "Finalized business planning and planned for risk",
      ],
    },
    {
      subject: "Build and maintain business relationships",
      description: [
        "Established business relationships",
        "Maintained business relationships",
        "Built and improved business relationships",
      ],
    },
  ],
};

export const dirm_lvl5_assessment_form = {
  name: "Level 5 Integrated Risk Management - Self Assessment Grid",
  img_urls: [
    "https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/e9814ceb3bc03fb52bfb22a2c174c349ff550337067efc79a04e363876b5ae37af1129bfcb422f9d09c4130af62f1698cbe36cc1f37f722a1aade4b33e55c28361c0f2240cb8ca240e43f4067b4c8ae8c95ec4737633f34cb66f50ddb249edabe6ce2aa9143ee48a81a560859697b940d84f0e277e1e9dfe5571/rez-file-1727069332281.png",
  ],
  list: [
    {
      subject: "ERM Principles",
      description: ["The 9 principles of ERM are applied"],
    },
    {
      subject:
        "Provide leadership and commitment to Integrated Enterprise Wide Risk Management (IERMF)",
      description: [
        "Prepared the organization for the development of an IERMF",
        "Promoted the need for leadership, commitment and integration",
      ],
    },
    {
      subject: "Design the IERMF",
      description: [
        "Reviewed the organizational context",
        "Prepared the IERMF implementation plan",
        "Developed the IERMF",
      ],
    },
    {
      subject: "Implementation of the IERMF",
      description: [
        "Socialized the IERMF",
        "Applied the risk management process steps",
      ],
    },
    {
      subject: "Monitor the IERMF",
      description: [
        "Monitored progress of the IERMF",
        "Reported on effectiveness of the IERMF",
      ],
    },
    {
      subject: "Continuously improve the IERMF",
      description: [
        "Identified and analyzed the impact of changes to the IERMF",
        "Reported and recommended area for improvement of the IERMF",
        "Implemented areas of improvement for the IERMF",
      ],
    },
    {
      subject: "Risk Technology (Software)",
      description: [
        "Analyzed organizational functional risk software requirements",
        "Sourced suitable software applications and suppliers",
        "Supervised the integration of selected risk software application",
        "Evaluated the effectiveness of the risk software solution",
      ],
    },
    {
      subject: "Implement Business Continuity Management (BCM)",
      description: [
        "Prepared the organization for BCM",
        "Delivered BCM",
        "Monitored and reviewed the BCM system",
        "Maintained the BCM system",
      ],
    },
  ],
};

export const dirm_lvl4_assessment_form = {
  name: "Level 4 Integrated Risk Management - Self Assessment Grid",
  img_urls: [
    "https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/2fc6e17e5741aa2e283f3d17916104ee428edd71dd22c93d7ae054a70d56403406eaf09637ad9a4d120ed1643e1418d7aa81e95aec0ded1f9c6f549cc261d9055a055f387dba4e8533227528234c87e33d44023e775b5eea7f888be6ea6f36e012644c57c014d3618e35e4634e185db8471be2a91a0c4488591e/rez-file-1727067604709.png",
  ],
  list: [
    {
      subject: "Engage with risk stakeholders",
      description: [
        "Identified internal and external stakeholders and their particular interests",
        "Drafted a communication & consultation plan",
        "Implemented a communication & consultation plan",
        "Conducted a review of a communication & consultation plan",
      ],
    },
    {
      subject: "Establish a risk environment",
      description: [
        "Created a risk management plan format",
        "Defined the scope to which the risk management process will be applied",
        "Defined the internal and external contexts",
        "Created risk criteria tables",
        "Classified risks into areas and categories",
      ],
    },
    {
      subject: "Conduct risk assessment",
      description: [
        "Recorded identified risks",
        "Conducted a risk analysis",
        "Applied risk evaluation criteria",
        "Finalized the risk register",
      ],
    },
    {
      subject: "Develop the treatment plans",
      description: [
        "Developed risk treatment options",
        "Determined the level of residual risk",
        "Finalized risk treatment plan",
        "Finalized the risk management plan",
      ],
    },
    {
      subject: "Monitor and review risks",
      description: [
        "Monitored & reviewed the risk management plan",
        "Monitored & reviewed the risk management process",
      ],
    },
    {
      subject: "Use risk management software",
      description: [
        "Prepared software for use",
        "Used software to follow the risk management process steps",
        "Secured software legal and contractual requirements",
      ],
    },
    {
      subject: "Develop a crisis management plan",
      description: [
        "Supported crisis planning",
        "Prepared a crisis management plan",
        "Tested a crisis management plan",
      ],
    },
  ],
};

export const pcp_assessment_form = {
  name: "Project Controls Practices - Self Assessment Grid",
  list: [
    {
      subject: "Establish the context",
      description: [
        "Been involved with a project of reasonable complexity with several phases, multiple activities with significant deliverables",
        "Been involved in project planning and developing key project documents such as the PMP, Schedule, budget, risk, and performance requirements",
        "Understood and applied organizational ethics and values to the project context",
        "Reviewed project initiation documentation",
      ],
    },
    {
      subject: "Apply configuration management processes & procedures",
      description: [
        "Identified the requirements for configuration management",
        "Implemented configuration management",
        "Monitored & reported on configuration management",
        "Maintained configuration management records",
      ],
    },
    {
      subject: "Apply professional ethics and values",
      description: [
        "Defined professional ethics and values",
        "Monitored the application of professional ethics and values",
        "Sought opportunities for self-improvement",
      ],
    },
    {
      subject: "Scope Management",
      description: [
        "Supported the PM to define project objectives, scope, constraints, assumptions and success criteria",
        "Defined the WBS, Control Accounts, Work Packages, and WBS Dictionaries",
      ],
    },
    {
      subject: "Assign Responsibility",
      description: [
        "Identified, analyzed and engaged with stakeholders",
        "Created a RACI & Organizational Breakdown Structure",
        "Created a risk register",
      ],
    },
    {
      subject: "Schedule Work",
      description: [
        "Completed estimates for effort and duration",
        "Created a resource leveled schedule",
        "Applied procurement/material management life cycle",
      ],
    },
    {
      subject: "Time Phased Budgeting",
      description: [
        "Completed cost estimates",
        "Created a time-phased budget",
        "Allocated resources to tasks",
      ],
    },
    {
      subject: "Assign an objective measure of performance",
      description: [
        "Determined Earned Value Performance Metrics",
        "Allocated EV metrics to WBS elements",
      ],
    },
    {
      subject: "Set performance measurement baseline",
      description: [
        "Integrated all project elements such as scope, cost, risk, and earned value",
      ],
    },
    {
      subject: "Authorize and perform the work",
      description: [
        "Confirmed all work is authorized to be undertaken",
        "Confirmed with all task leads their responsibilities for completing the work",
      ],
    },
    {
      subject: "Accumulate and report data",
      description: [
        "Accessed financial data (Actual Costs)",
        "Recorded schedule and cost and scope performance",
        "Prepared reports on project performance",
      ],
    },
    {
      subject: "Analyze project performance data",
      description: [
        "Compared current data on project performance with previous periods",
        "Prepared forecasts for project costs and schedule to complete and at completion",
        "Made recommendations to project authority",
      ],
    },
    {
      subject: "Take management action",
      description: [
        "Prepared change requests",
        "Analyzed impact of changes on baseline",
      ],
    },
    {
      subject: "Maintain the baseline",
      description: [
        "Updated project documentation based on agreed changes",
        "Distributed updated project documentation",
      ],
    },
    {
      subject: "Project Closure",
      description: [
        "Closed subcontracts",
        "Contributed to project lessons learned register",
        "Closed/transferred risks",
        "Provided advice on any contingency funds remaining",
        "Reviewed and validated all costings to project",
        "Prepared a project closure report",
      ],
    },
  ],
};

// Results Range Data
export const dpm_assessment_result = {
  lower_range: {
    min_value: 0,
    max_value: 53,
    recommendations:
      "Attend the BSB40920 Certificate IV in Project Management Practices as a first step, then move onto a BSB50820 Diploma of Project Management after 6-12 months workplace application. Contact our team on (07) 33432924 or info@itpl.com.au",
  },
  middle_range: {
    min_value: 54,
    max_value: 80,
    recommendations:
      "A mentored development pathway/blended learning pathway is more likely the best option to achieve your BSB50820 Diploma of Project Management, with a focus on those specific areas requiring attention.  Contact our team on (07) 33432924 or info@itpl.com.au",
  },
  upper_range: {
    min_value: 81,
    max_value: 108,
    recommendations:
      "Go through an RPL process to achieve your BSB50820 Diploma of Project Management. Contact our team on (07) 33432924 or info@itpl.com.au",
  },
};

export const adpm_assessment_result = {
  lower_range: {
    min_value: 0,
    max_value: 92,
    recommendations:
      "Attend the BSB50820 Diploma of Project Management as a first step. Contact our team on (07) 33432924 or info@itpl.com.au",
  },
  middle_range: {
    min_value: 93,
    max_value: 137,
    recommendations:
      "A mentored development pathway/blended learning pathway is more likely the best option to achieve your BSB60720 Advanced Diploma of Program Management, with a focus on those specific areas requiring attention.  Contact our team on (07) 33432924 or info@itpl.com.au",
  },
  upper_range: {
    min_value: 138,
    max_value: 224,
    recommendations:
      "Consider going through an RPL process to achieve your BSB60720 Advanced Diploma of Program Management. Contact our team on (07) 33432924 or info@itpl.com.au",
  },
};

export const dc_assessment_result = {
  lower_range: {
    min_value: 0,
    max_value: 90,
    recommendations:
      "Attend the 11444NAT Diploma of Consultancy as a first step. Contact our team on (07) 33432924 or info@itpl.com.au",
  },
  middle_range: {
    min_value: 91,
    max_value: 120,
    recommendations:
      "A mentored development pathway is more likely the best option to achieve your 11444NAT Diploma of Consultancy with a focus on those specific areas requiring attention.  Contact our team on (07) 33432924 or info@itpl.com.au",
  },
  upper_range: {
    min_value: 121,
    max_value: 144,
    recommendations:
      "Go through an RPL process to achieve your 11444NAT Diploma of Consultancy.  Contact our team on (07) 33432924 or info@itpl.com.au",
  },
};

export const dirm_lvl5_assessment_result = {
  lower_range: {
    min_value: 0,
    max_value: 40,
    recommendations:
      "Attend the 11411NAT Certificate IV in Integrated Risk Management as a first step. Contact our team on (07) 33432924 or info@itpl.com.au",
  },
  lower_middle_range: {
    min_value: 41,
    max_value: 59,
    recommendations:
      "Attend the 11415NAT Diploma of Integrated Risk Management facilitated workshops. Contact our team on (07) 33432924 or info@itpl.com.au",
  },
  upper_middle_range: {
    min_value: 60,
    max_value: 70,
    recommendations:
      "A mentored development pathway is more likely the best option to achieve your 11415NAT Diploma of Integrated Risk Management, with a focus on those specific areas requiring attention. Contact our team on (07) 33432924 or info@itpl.com.au",
  },
  upper_range: {
    min_value: 71,
    max_value: 84,
    recommendations:
      "Go through an RPL process to achieve your 11415NAT Diploma of Integrated Risk Management. Contact our team on (07) 33432924 or info@itpl.com.au",
  },
};

export const dirm_lvl4_assessment_result = {
  lower_range: {
    min_value: 0,
    max_value: 60,
    recommendations:
      "Enroll in the 11411NAT Certificate IV in Integrated Risk Management as a first step. Contact our team on (07) 33432924 or info@itpl.com.au",
  },
  middle_range: {
    min_value: 61,
    max_value: 79,
    recommendations:
      "A mentored development/blended learning pathway is more likely the best option to achieve your 11411NAT Certificate IV in Integrated Risk Management, with a focus on those specific areas requiring attention. Contact our team on (07) 33432924 or info@itpl.com.au",
  },
  upper_range: {
    min_value: 80,
    max_value: 100,
    recommendations:
      "Go through an RPL process to achieve your 11411NAT Certificate IV in Integrated Risk Management. Contact our team on (07) 33432924 or info@itpl.com.au",
  },
};

export const pcp_assessment_result = {
  lower_range: {
    min_value: 0,
    max_value: 85,
    recommendations:
      "Attend the 11399NAT Certificate IV in Project Controls Practices as a first step. Contact our team on (07) 33432924 or info@itpl.com.au",
  },
  middle_range: {
    min_value: 86,
    max_value: 128,
    recommendations:
      "A mentored development pathway/blended learning pathway is more likely the best option to achieve your 11399NAT Certificate IV in Project Controls Practices, with a focus on those specific areas requiring attention.  Contact our team on (07) 33432924 or info@itpl.com.au",
  },
  upper_range: {
    min_value: 129,
    max_value: 172,
    recommendations:
      "Go through an RPL process to achieve your 11399NAT Certificate IV in Project Controls Practices. Contact our team on (07) 33432924 or info@itpl.com.au",
  },
};

// Privacy Notice
export const privacy_notice = [
  {
    description: (
      <p className="leading-8 md:leading-10">
        Under the Data Provision Requirements 2012, Interlink Technology
        Services Pty Ltd is required to collect personal information about you
        and to disclose that personal information to the National Centre for
        Vocational Education Research Ltd (NCVER).
      </p>
    ),
  },
  {
    title: "Why we collect your personal information",
    description: (
      <p className="leading-8 md:leading-10">
        As a registered training organisation (RTO), we collect your personal
        information so we can process and manage your enrolment in a vocational
        education and training (VET) course with us.
      </p>
    ),
  },
  {
    title: "How we use your personal information",
    description: (
      <p className="leading-8 md:leading-10">
        We use your personal information to enable us to deliver VET courses to
        you, and otherwise, as needed, to comply with our obligations as an RTO.
      </p>
    ),
  },
  {
    title: "How we disclose your personal information",
    description: (
      <p className="leading-8 md:leading-10">
        We are required by law (under the National Vocational Education and
        Training Regulator Act 2011 (Cth) (NVETR Act)) to disclose the personal
        information we collect about you to the National VET Data Collection
        kept by the National Centre for Vocational Education Research Ltd
        (NCVER). The NCVER is responsible for collecting, managing, analysing
        and communicating research and statistics about the Australian VET
        sector.
      </p>
    ),
  },
  {
    description: (
      <p className="leading-8 md:leading-10">
        We are also authorised by law (under the NVETR Act) to disclose your
        personal information to the relevant state or territory training
        authority.
      </p>
    ),
  },
  {
    title: "How we disclose your personal information",
    description: (
      <>
        <p className="leading-8 md:leading-10">
          The NCVER will collect, hold, use and disclose your personal
          information in accordance with the law, including the Privacy Act 1988
          (Cth) (Privacy Act) and the NVETR Act. Your personal information may
          be used and disclosed by NCVER for purposes that include populating
          authenticated VET transcripts; administration of VET; facilitation of
          statistics and research relating to education, including surveys and
          data linkage; and understanding the VET market.
        </p>
        <p className="leading-8 md:leading-10">
          The NCVER is authorised to disclose information to the Australian
          Government Department of Education, Skills and Employment (DESE),
          Commonwealth Authorities, State and Territory Authorities (other than
          registered training organisations) that deal with matters relating to
          VET and VET regulators for the purposes of those bodies, including to
          enable:
        </p>
        <ul className="space-y-4 list-disc">
          <li className="pl-1 ml-4 sm:ml-6 sm:pl-2">
            administration of VET, including program administration, regulation,
            monitoring and evaluation
          </li>
          <li className="pl-1 ml-4 sm:ml-6 sm:pl-2">
            facilitation of statistics and research relating to education,
            including surveys and data linkage
          </li>
          <li className="pl-1 ml-4 sm:ml-6 sm:pl-2">
            understanding how the VET market operates, for policy, workforce
            planning and consumer information.
          </li>
        </ul>
        <p className="leading-8 md:leading-10">
          The NCVER may also disclose personal information to persons engaged by
          NCVER to conduct research on NCVER’s behalf. The NCVER does not intend
          to disclose your personal information to any overseas recipients. For
          more information about how the NCVER will handle your personal
          information please refer to the NCVER’s Privacy Policy at{" "}
          <a
            className="underline text-sky-500"
            href="https://www.ncver.edu.au/privacy"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://www.ncver.edu.au/privacy
          </a>
          .
        </p>
        <p className="leading-8 md:leading-10">
          If you would like to seek access to or correct your information, in
          the first instance, please contact your RTO using the contact details
          listed below.
        </p>
        <p className="leading-8 md:leading-10">
          DESE is authorised by law, including the Privacy Act and the NVETR
          Act, to collect, use and disclose your personal information to fulfil
          specified functions and activities. For more information about how the
          DESE will handle your personal information, please refer to the DESE
          VET Privacy Notice at{" "}
          <a
            className="underline text-sky-500"
            href="https://www.dese.gov.au/national-vet-data/vet-privacy-notice"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://www.dese.gov.au/national-vet-data/vet-privacy-notice
          </a>
          .
        </p>
      </>
    ),
  },
  {
    title: "Surveys",
    description: (
      <p className="leading-8 md:leading-10">
        You may receive a student survey which may be run by a government
        department or an NCVER employee, agent, third-party contractor or
        another authorised agency. Please note you may opt out of the survey at
        the time of being contacted.
      </p>
    ),
  },
  {
    title: "Contact Information",
    description: (
      <>
        <p className="leading-8 md:leading-10">
          At any time, you may contact Interlink Technology Services Pty Ltd to:
        </p>
        <ul className="space-y-4 list-disc">
          <li className="pl-1 ml-4 sm:ml-6 sm:pl-2">
            request access to your personal information
          </li>
          <li className="pl-1 ml-4 sm:ml-6 sm:pl-2">
            correct your personal information
          </li>
          <li className="pl-1 ml-4 sm:ml-6 sm:pl-2">
            make a complaint about how your personal information has been
            handled
          </li>
          <li className="pl-1 ml-4 sm:ml-6 sm:pl-2">
            ask a question about this Privacy Notice
          </li>
        </ul>
      </>
    ),
  },
];

// Disablity Supplement
export const disability_supplement = (forPdf, values) => {
  return [
    {
      ...(forPdf
        ? {
            description:
              "<p>Disability in this context does not include short-term disabling health conditions such as a fractured leg, influenza, or corrected physical conditions such as impaired vision managed by wearing glasses or lenses.</p>",
          }
        : {
            description: (
              <p>
                Disability in this context does not include short-term disabling
                health conditions such as a fractured leg, influenza, or
                corrected physical conditions such as impaired vision managed by
                wearing glasses or lenses.
              </p>
            ),
          }),
    },
    {
      ...(forPdf
        ? {
            title: `<input ${
              values.disabilities
                .map((item) => {
                  return item.value.split(" – ")[1];
                })
                .includes("Hearing / Deaf") === true
                ? "checked"
                : ""
            } disabled type='checkbox' id='disabilities-supplement-checkbox-btn-1' name='disabilities-supplement-1' style='margin-top: 5px; width: 25px; height: 25px;' /><p style='font-size: 20px;font-weight: 700;'>11 — Hearing / Deaf</p>`,
          }
        : {
            title: (
              <>
                <div>
                  <input
                    type="checkbox"
                    className="w-4 h-4 mt-1 text-blue-600 bg-gray-100 border-gray-300 md:w-6 md:h-6 peer-checked:bg-sky-600"
                  />
                </div>
                <p className="text-lg font-bold sm:text-xl xl:text-2xl">
                  11 — Hearing / Deaf
                </p>
              </>
            ),
          }),
      ...(forPdf
        ? {
            description:
              "<p>Hearing impairment is used to refer to a person who has an acquired mild, moderate, severe or profound hearing loss after learning to speak, communicates orally and maximizes residual hearing with the assistance of amplification. A person who is deaf has a severe or profound hearing loss from, at, or near birth and mainly relies upon vision to communicate, whether through lip reading, gestures, cued speech, finger spelling and/or sign language.</p>",
          }
        : {
            description: (
              <p>
                Hearing impairment is used to refer to a person who has an
                acquired mild, moderate, severe or profound hearing loss after
                learning to speak, communicates orally and maximizes residual
                hearing with the assistance of amplification. A person who is
                deaf has a severe or profound hearing loss from, at, or near
                birth and mainly relies upon vision to communicate, whether
                through lip reading, gestures, cued speech, finger spelling
                and/or sign language.
              </p>
            ),
          }),
    },
    {
      ...(forPdf
        ? {
            title: `<input ${
              values.disabilities
                .map((item) => {
                  return item.value.split(" – ")[1];
                })
                .includes("Physical") === true
                ? "checked"
                : ""
            } disabled type='checkbox' id='disabilities-supplement-checkbox-btn-2' name='disabilities-supplement-2' style='margin-top: 5px; width: 25px; height: 25px;' /><p style='font-size: 20px;font-weight: 700;'>12 — Physical</p>`,
          }
        : {
            title: (
              <>
                <div>
                  <input
                    type="checkbox"
                    className="w-4 h-4 mt-1 text-blue-600 bg-gray-100 border-gray-300 md:w-6 md:h-6 peer-checked:bg-sky-600"
                  />
                </div>
                <p className="text-lg font-bold sm:text-xl xl:text-2xl">
                  12 — Physical
                </p>
              </>
            ),
          }),
      ...(forPdf
        ? {
            description:
              "<p>A physical disability affects the mobility or dexterity of a person and may include a total or partial loss of a part of the body. A physical disability may have existed since birth or may be the result of an accident, illness, or injury suffered later in life; for example, amputation, arthritis, cerebral palsy, multiple sclerosis, muscular dystrophy, paraplegia, quadriplegia or post-polio syndrome.</p>",
          }
        : {
            description: (
              <p>
                A physical disability affects the mobility or dexterity of a
                person and may include a total or partial loss of a part of the
                body. A physical disability may have existed since birth or may
                be the result of an accident, illness, or injury suffered later
                in life; for example, amputation, arthritis, cerebral palsy,
                multiple sclerosis, muscular dystrophy, paraplegia, quadriplegia
                or post-polio syndrome.
              </p>
            ),
          }),
    },
    {
      ...(forPdf
        ? {
            title: `<input ${
              values.disabilities
                .map((item) => {
                  return item.value.split(" – ")[1];
                })
                .includes("Intelectual") === true
                ? "checked"
                : ""
            } disabled type='checkbox' id='disabilities-supplement-checkbox-btn-3' name='disabilities-supplement-3' style='margin-top: 5px; width: 25px; height: 25px;' /><p style='font-size: 20px;font-weight: 700;'>13 — Intellectual</p>`,
          }
        : {
            title: (
              <>
                <div>
                  <input
                    type="checkbox"
                    className="w-4 h-4 mt-1 text-blue-600 bg-gray-100 border-gray-300 md:w-6 md:h-6 peer-checked:bg-sky-600"
                  />
                </div>
                <p className="text-lg font-bold sm:text-xl xl:text-2xl">
                  13 — Intellectual
                </p>
              </>
            ),
          }),
      ...(forPdf
        ? {
            description:
              "<p>In general, the term ‘intellectual disability’ is used to refer to low general intellectual functioning and difficulties in adaptive behaviour, both of which conditions were manifested before the person reached the age of 18. It may result from infection before or after birth, trauma during birth, or illness.</p>",
          }
        : {
            description: (
              <p>
                In general, the term ‘intellectual disability’ is used to refer
                to low general intellectual functioning and difficulties in
                adaptive behaviour, both of which conditions were manifested
                before the person reached the age of 18. It may result from
                infection before or after birth, trauma during birth, or
                illness.
              </p>
            ),
          }),
    },
    {
      ...(forPdf
        ? {
            title: `<input ${
              values.disabilities
                .map((item) => {
                  return item.value.split(" – ")[1];
                })
                .includes("Learning") === true
                ? "checked"
                : ""
            } disabled type='checkbox' id='disabilities-supplement-checkbox-btn-4' name='disabilities-supplement-4' style='margin-top: 5px; width: 25px; height: 25px;' /><p style='font-size: 20px;font-weight: 700;'>14 — Learning</p>`,
          }
        : {
            title: (
              <>
                <div>
                  <input
                    type="checkbox"
                    className="w-4 h-4 mt-1 text-blue-600 bg-gray-100 border-gray-300 md:w-6 md:h-6 peer-checked:bg-sky-600"
                  />
                </div>
                <p className="text-lg font-bold sm:text-xl xl:text-2xl">
                  14 — Learning
                </p>
              </>
            ),
          }),
      ...(forPdf
        ? {
            description:
              "<p>A general term that refers to a heterogeneous group of disorders manifested by significant difficulties in the acquisition and use of listening, speaking, reading, writing, reasoning, or mathematical abilities. These disorders are intrinsic to the individual, presumed to be due to central nervous system dysfunction, and may occur across the life span. Problems in self-regulatory behaviours, social perception, and social interaction may exist with learning disabilities but do not by themselves constitute a learning disability.</p>",
          }
        : {
            description: (
              <p>
                A general term that refers to a heterogeneous group of disorders
                manifested by significant difficulties in the acquisition and
                use of listening, speaking, reading, writing, reasoning, or
                mathematical abilities. These disorders are intrinsic to the
                individual, presumed to be due to central nervous system
                dysfunction, and may occur across the life span. Problems in
                self-regulatory behaviours, social perception, and social
                interaction may exist with learning disabilities but do not by
                themselves constitute a learning disability.
              </p>
            ),
          }),
    },
    {
      ...(forPdf
        ? {
            title: `<input ${
              values.disabilities
                .map((item) => {
                  return item.value.split(" – ")[1];
                })
                .includes("Mental Illness") === true
                ? "checked"
                : ""
            } disabled type='checkbox' id='disabilities-supplement-checkbox-btn-5' name='disabilities-supplement-5' style='margin-top: 5px; width: 25px; height: 25px;' /><p style='font-size: 20px;font-weight: 700;'>15 — Mental Illness</p>`,
          }
        : {
            title: (
              <>
                <div>
                  <input
                    type="checkbox"
                    className="w-4 h-4 mt-1 text-blue-600 bg-gray-100 border-gray-300 md:w-6 md:h-6 peer-checked:bg-sky-600"
                  />
                </div>
                <p className="text-lg font-bold sm:text-xl xl:text-2xl">
                  15 — Mental Illness
                </p>
              </>
            ),
          }),
      ...(forPdf
        ? {
            description:
              "<p>Mental illness refers to a cluster of psychological and physiological symptoms that cause a person suffering or distress and which represent a departure from a person’s usual pattern and level of functioning.</p>",
          }
        : {
            description: (
              <p>
                Mental illness refers to a cluster of psychological and
                physiological symptoms that cause a person suffering or distress
                and which represent a departure from a person’s usual pattern
                and level of functioning.
              </p>
            ),
          }),
    },
    {
      ...(forPdf
        ? {
            title: `<input ${
              values.disabilities
                .map((item) => {
                  return item.value.split(" – ")[1];
                })
                .includes("Acquired Brain Impairment") === true
                ? "checked"
                : ""
            } disabled type='checkbox' id='disabilities-supplement-checkbox-btn-6' name='disabilities-supplement-6' style='margin-top: 5px; width: 25px; height: 25px;' /><p style='font-size: 20px;font-weight: 700;'>16 — Acquired Brain Impairment</p>`,
          }
        : {
            title: (
              <>
                <div>
                  <input
                    type="checkbox"
                    className="w-4 h-4 mt-1 text-blue-600 bg-gray-100 border-gray-300 md:w-6 md:h-6 peer-checked:bg-sky-600"
                  />
                </div>
                <p className="text-lg font-bold sm:text-xl xl:text-2xl">
                  16 — Acquired Brain Impairment
                </p>
              </>
            ),
          }),
      ...(forPdf
        ? {
            description:
              "<p>Acquired brain impairment is injury to the brain that results in deterioration in cognitive, physical, emotional or independent functioning. Acquired brain impairment can occur as a result of trauma, hypoxia, infection, tumour, accidents, violence, substance abuse, degenerative neurological diseases or stroke. These impairments may be either temporary or permanent and cause partial or total disability or psychosocial maladjustment.</p>",
          }
        : {
            description: (
              <p>
                Acquired brain impairment is injury to the brain that results in
                deterioration in cognitive, physical, emotional or independent
                functioning. Acquired brain impairment can occur as a result of
                trauma, hypoxia, infection, tumour, accidents, violence,
                substance abuse, degenerative neurological diseases or stroke.
                These impairments may be either temporary or permanent and cause
                partial or total disability or psychosocial maladjustment.
              </p>
            ),
          }),
    },
    {
      ...(forPdf
        ? {
            title: `<input ${
              values.disabilities
                .map((item) => {
                  return item.value.split(" – ")[1];
                })
                .includes("Vision") === true
                ? "checked"
                : ""
            } disabled type='checkbox' id='disabilities-supplement-checkbox-btn-7' name='disabilities-supplement-7' style='margin-top: 5px; width: 25px; height: 25px;' /><p style='font-size: 20px;font-weight: 700;'>17 — Vision</p>`,
          }
        : {
            title: (
              <>
                <div>
                  <input
                    type="checkbox"
                    className="w-4 h-4 mt-1 text-blue-600 bg-gray-100 border-gray-300 md:w-6 md:h-6 peer-checked:bg-sky-600"
                  />
                </div>
                <p className="text-lg font-bold sm:text-xl xl:text-2xl">
                  17 — Vision
                </p>
              </>
            ),
          }),
      ...(forPdf
        ? {
            description:
              "<p>This covers a partial loss of sight causing difficulties in seeing, up to and including blindness. This may be present from birth or acquired as a result of disease, illness or injury.</p>",
          }
        : {
            description: (
              <p>
                This covers a partial loss of sight causing difficulties in
                seeing, up to and including blindness. This may be present from
                birth or acquired as a result of disease, illness or injury.
              </p>
            ),
          }),
    },
    {
      ...(forPdf
        ? {
            title: `<input ${
              values.disabilities
                .map((item) => {
                  return item.value.split(" – ")[1];
                })
                .includes("Medical Condition") === true
                ? "checked"
                : ""
            } disabled type='checkbox' id='disabilities-supplement-checkbox-btn-8' name='disabilities-supplement-8' style='margin-top: 5px; width: 25px; height: 25px;' /><p style='font-size: 20px;font-weight: 700;'>18 — Medical Condition</p>`,
          }
        : {
            title: (
              <>
                <div>
                  <input
                    type="checkbox"
                    className="w-4 h-4 mt-1 text-blue-600 bg-gray-100 border-gray-300 md:w-6 md:h-6 peer-checked:bg-sky-600"
                  />
                </div>
                <p className="text-lg font-bold sm:text-xl xl:text-2xl">
                  18 — Medical Condition
                </p>
              </>
            ),
          }),
      ...(forPdf
        ? {
            description:
              "<p>Medical condition is a temporary or permanent condition that may be hereditary, genetically acquired or of unknown origin. The condition may not be obvious or readily identifiable, yet may be mildly or severely debilitating and result in fluctuating levels of wellness and sickness, and/or periods of hospitalisation; for example, HIV/AIDS, cancer, chronic fatigue syndrome, Crohn’s disease, cystic fibrosis, asthma or diabetes.</p>",
          }
        : {
            description: (
              <p>
                Medical condition is a temporary or permanent condition that may
                be hereditary, genetically acquired or of unknown origin. The
                condition may not be obvious or readily identifiable, yet may be
                mildly or severely debilitating and result in fluctuating levels
                of wellness and sickness, and/or periods of hospitalisation; for
                example, HIV/AIDS, cancer, chronic fatigue syndrome, Crohn’s
                disease, cystic fibrosis, asthma or diabetes.
              </p>
            ),
          }),
    },
    {
      ...(forPdf
        ? {
            title: `<input ${
              values.disabilities
                .map((item) => {
                  return item.value.split(" – ")[1];
                })
                .includes("Other") === true
                ? "checked"
                : ""
            } disabled type='checkbox' id='disabilities-supplement-checkbox-btn-9' name='disabilities-supplement-9' style='margin-top: 5px; width: 25px; height: 25px;' /><p style='font-size: 20px;font-weight: 700;'>19 — Other</p>`,
          }
        : {
            title: (
              <>
                <div>
                  <input
                    type="checkbox"
                    className="w-4 h-4 mt-1 text-blue-600 bg-gray-100 border-gray-300 md:w-6 md:h-6 peer-checked:bg-sky-600"
                  />
                </div>
                <p className="text-lg font-bold sm:text-xl xl:text-2xl">
                  19 — Other
                </p>
              </>
            ),
          }),
      ...(forPdf
        ? {
            description:
              "<p>A disability, impairment or long-term condition which is not suitably described by one or several disability types in combination. Autism spectrum disorders are reported under this category.</p>",
          }
        : {
            description: (
              <p>
                A disability, impairment or long-term condition which is not
                suitably described by one or several disability types in
                combination. Autism spectrum disorders are reported under this
                category.
              </p>
            ),
          }),
    },
  ];
};

// Registration Form
export const options = [
  {
    title: "Yes",
    value: true,
  },
  {
    title: "No",
    value: false,
  },
];

export const qualifications = [
  {
    title: "11411NAT Certificate IV in Integrated Risk Management",
  },
  {
    title: "11399NAT Certificate IV in Project Controls Practices",
  },
  {
    title: "11415NAT Diploma of Integrated Risk Management",
  },
  {
    title: "11444NAT Diploma of Consultancy",
  },
  {
    title: "BSB40920 Certificate IV in Project Management Practices",
  },
  {
    title: "BSB50820 Diploma of Project Management",
  },
  {
    title: "BSB60720 Advanced Diploma of Program Management",
  },
  // {
  //     title: "11444NAT Diploma of Consultancy Management"
  // },
  // {
  //     title: "TLIX0055 Conduct Configuration Management (Unit Only)"
  // },
];

export const how_do_you_find_us_options = [
  {
    id: "IMC",
    text: "IMC",
  },
  {
    id: "RMIA",
    text: "RMIA",
  },
  {
    id: "Inspire PT",
    text: "Inspire PT",
  },
  {
    id: "AIM",
    text: "AIM",
  },
  {
    id: "Internet Search",
    text: "Internet Search",
  },
  {
    id: "Student Referral",
    text: "Student Referral",
  },
  {
    id: "Past Student",
    text: "Past Student",
  },
  {
    id: "Other",
    text: "Other",
  },
];

export const titles = [
  {
    title: "Mr.",
  },
  {
    title: "Mrs.",
  },
  {
    title: "Miss",
  },
  {
    title: "Ms.",
  },
  {
    title: "Dr.",
  },
  {
    title: "Other",
  },
];

export const genders = [
  {
    title: "Male",
  },
  {
    title: "Female",
  },
  {
    title: "Other / Not Specified",
  },
];

export const address_options = [
  {
    title: "My postal address is the same with residence address.",
    value: true,
  },
  {
    title: "My postal address is different with residence address.",
    value: false,
  },
];

export const diversities = [
  {
    title: "1 – Yes, Aboriginal",
  },
  {
    title: "2 – Yes, Torres Strait Islander",
  },
  {
    title: "3 – Yes, To Both (Aboriginal and Torres Strait Islander)",
  },
  {
    title: "4 – No",
  },
];

export const disabilities = [
  {
    label: "11 – Hearing / Deaf",
    value: "11 – Hearing / Deaf",
  },
  {
    label: "12 – Physical",
    value: "12 – Physical",
  },
  {
    label: "13 – Intelectual",
    value: "13 – Intelectual",
  },
  {
    label: "14 – Learning",
    value: "14 – Learning",
  },
  {
    label: "15 – Mental Illness",
    value: "15 – Mental Illness",
  },
  {
    label: "16 – Acquired Brain Impairment",
    value: "16 – Acquired Brain Impairment",
  },
  {
    label: "17 – Vision",
    value: "17 – Vision",
  },
  {
    label: "18 – Medical Condition",
    value: "18 – Medical Condition",
  },
  {
    label: "19 – Other",
    value: "19 – Other",
  },
];

export const levels = [
  {
    title: "12 – Year 12 or equivalent",
  },
  {
    title: "11 – Year 11 or equivalent",
  },
  {
    title: "10 – Year 10 or equivalent",
  },
  {
    title: "09 – Year 9 or equivalent",
  },
  {
    title: "08 – Year 8 or below",
  },
  {
    title: "02 – Never Attended School",
  },
];

export const previous_qualifications = [
  {
    label: "008 – Bachelor Degree or Higher Degree",
    value: "008 – Bachelor Degree or Higher Degree",
  },
  {
    label: "410 – Advanced Diploma or Associate Degree",
    value: "410 – Advanced Diploma or Associate Degree",
  },
  {
    label: "420 – Diploma (or Associate Diploma)",
    value: "420 – Diploma (or Associate Diploma)",
  },
  {
    label: "511 – Certificate IV (or Advanced Certificate / Technician)",
    value: "511 – Certificate IV (or Advanced Certificate / Technician)",
  },
  {
    label: "514 – Certificate III (or Trade Certificate)",
    value: "514 – Certificate III (or Trade Certificate)",
  },
  {
    label: "521 – Certificate II",
    value: "521 – Certificate II",
  },
  {
    label: "524 – Certificate I",
    value: "524 – Certificate I",
  },
  {
    label:
      "990 – Other Education (including certificates or overseas qualifications not listed above)",
    value:
      "990 – Other Education (including certificates or overseas qualifications not listed above)",
  },
];

export const received_gov_fund_options = [
  {
    title: "YES: Advise Qualification",
    value: true,
  },
  {
    title: "N/A: Not Applicable",
    value: false,
  },
];

export const employment = [
  {
    title: "01 – Full-Time Employee",
  },
  {
    title: "02 – Part-Time Employee",
  },
  {
    title: "03 – Self Employed - Not Employing Others",
  },
  {
    title: "04 – Self Employed - Employing Others",
  },
  {
    title: "05 – Employed - Unpaid Workers in a Family Business",
  },
  {
    title: "06 – Unemployed - Seeking Full-Time Work",
  },
  {
    title: "07 – Unemployed - Seeking Part-Time Work",
  },
  {
    title: "08 – Not Employed - Not Seeking Employment",
  },
];

export const study_reasons = [
  {
    title: "01 – To get a job",
  },
  {
    title: "02 – To develop my existing business",
  },
  {
    title: "03 – To start my own business",
  },
  {
    title: "04 – To try for a different career",
  },
  {
    title: "05 – To get a better job or promotion",
  },
  {
    title: "06 – It was a requirement of my job",
  },
  {
    title: "07 – I wanted extra skills for my job",
  },
  {
    title: "08 – To get into another course of study",
  },
  {
    title: "12 – For personal interest or self-development",
  },
  {
    title: "13 – To get skills for community/voluntary work",
  },
  {
    title: "11 – Other reasons",
  },
];

export const payments = [
  {
    title:
      "Cash (Maximum $1500 for individuals can be paid on first installment)",
  },
  {
    title:
      "Electronic Funds Transfer (EFT) – (Max $1500.00 first payment) Bank details will be supplied, and invoice issued",
  },
  {
    title:
      "Invoice Required – Payment terms are $1500 per installment until payment is complete for private individuals",
  },
  {
    title:
      "Invoice Required – Corporate Invoice under separate Terms & Conditions",
  },
  {
    title:
      "Direct Debit (Please complete Interlink Technology Services Direct Debit Request Form)",
  },
];

export const instructions = [
  {
    desc: "I understand that information contained in these forms may be provided to State a Commonwealth agencies and research organisations and I consent to that occurring. I certify that all details provided on these forms are correct.",
  },
  {
    desc: "I have received a copy of ITS Candidate Handbook which contains program information, including content and award (Qualification or Statement of Attainment) information.",
  },
  {
    desc: "I have been advised via the ITS Candidate Handbook regarding:",
  },
];

export const declarations = [
  {
    title: "Enrolment and start-up procedures",
  },
  {
    title: "Mutual recognition obligations",
  },
  {
    title: "Fees and charges, and refund policy",
  },
  {
    title: "Procedures learning options and assessment procedures",
  },
  {
    title:
      "Assessment policy and reasonable adjustment procedures for participants with special needs provision for language, literacy and numeracy evaluation",
  },
  {
    title:
      "Client support, including any external support which ITS can arrange if required access and equity policy and procedures",
  },
  {
    title: "Complaints, appeals and grievance timeframes policies/processes",
  },
  {
    title: "RPL and Credit Transfer arrangements",
  },
  {
    title:
      "Procedures/arrangements for feedback, to and from the candidate during any program.",
  },
];
